import React from 'react'
import styled, { withTheme } from 'styled-components'
import { Wrapper } from '../../../containers/Wrapper'
import AuthorBadge from './AuthorBadge'
import MapBackground from './MapBackground'

const Border = styled.div`
    position: relative;
    height: 1px;
    background:${props => `${props.theme.colors.primary}50`};
    width: 60%;
    display:flex;
    align-items: center;

    &::before, 
    &::after{
        position: absolute;
        content: " ";
        display:block;
        width:5px;
        height:5px;
        border-radius: 50%;
        background-color:${props => props.theme.colors.primary};
    }

    &::after{
        right:0;
    }

    @media (max-width: ${props => props.theme.pageWidth.l}px) {
        margin-top:60%;
    }

    @media (max-width: ${props => props.theme.pageWidth.s}px) {
        width: 94%;
        margin-top: 40%;
    }
`

const MainTextContainer = styled.div`
    position: relative;
    font-family:${props => props.theme.fonts.display};
    width: 60%;
    padding-top: 100px;
    padding-bottom: 30px;
    color:${props => props.theme.colors.primary};
    z-index: 200;


    h1 {
        padding-top:20px;
        padding-bottom:20px;
        font-weight: 400;
        font-size: 3rem;
        line-height: 1.29;
        letter-spacing: -2.4px;
        text-transform: uppercase;
    }

    @media (min-width: ${props => props.theme.pageWidth.xl}px) {
        margin-left: 3.5rem;
    }

    @media (max-width: ${props => props.theme.pageWidth.l}px) {
        width: 90%;
    }

    @media (max-width: ${props => props.theme.pageWidth.s}px) {
        width: 90%;
        padding-left: 20px;
        padding-right: 20px;

        h1 {
            font-size: 1.5em;
            line-height: 1.33;
        }
    }
`

const IntroContainer = styled.div`
    position: relative;
`;

const Intro = (props) => {
    return (
        <IntroContainer>
            <MapBackground
                cityName={props.cityName}
                mapImage={props.mapImage}
                mapImageAlt={props.mapImageAlt}
                pinImage={props.pinImage}
                pinImageAlt={props.pinImageAlt}
                bgPositionX={props.bgPositionX}
                bgPositionY={props.bgPositionY}
                pinPositionX={props.pinPositionX}
                pinPositionY={props.pinPositionY}
                bgColor={props.mapBgColor}
            ></MapBackground>
            <Wrapper>
                <MainTextContainer>
                    <Border></Border>
                    <h1>{props.introText}</h1>
                    <AuthorBadge></AuthorBadge>
                </MainTextContainer>
            </Wrapper>
        </IntroContainer>
    );
};

export default withTheme(Intro); 